import {localStorageKey} from 'core/constants';

export const getLimitsErrorEmulationFlag = () => {
  return localStorage.getItem(localStorageKey.EmulateLimitError) === '1';
};

export const getCustomLimitValue = () => {
  return localStorage.getItem(localStorageKey.CustomLimitValue);
};
